import Swal from "sweetalert2";
export const handleTransferStatusUpdate = async (transferId, status, {fetchData, setUpdatingTransferStatus, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
        setUpdatingTransferStatus(transferId);
        await contact.updateTransferStatus(transferId, status);
        fetchData();
        await Swal.fire({
        icon: "success",
        title: "Success",
        text: `Transfer status updated to ${status}`,
        confirmButtonColor: "#1e3a8a",
        });
    } catch (error) {
        console.error("Error updating transfer status:", error);
        await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update transfer status. Please try again.",
        confirmButtonColor: "#1e3a8a",
        });
    } finally {
        setUpdatingTransferStatus(null);
    }
    };

